import { IconAccountCircle } from '@tvg/fuse-icons';
import PropTypes from 'prop-types';
import React from 'react';
import { StyledIconButton, iconButtonSizeConfig } from './styled-icon-button';

const propTypes = {
	href: PropTypes.string.isRequired,
	text: PropTypes.string.isRequired,
	dataTestId: PropTypes.string,
	notification: PropTypes.string,
	disabled: PropTypes.bool,
	icon: PropTypes.element,
	size: PropTypes.oneOfType([
		PropTypes.oneOf(Object.keys(iconButtonSizeConfig)),
		PropTypes.shape(
			['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl'].reduce(
				(acc, current) => ({
					...acc,
					[current]: PropTypes.oneOf(Object.keys(iconButtonSizeConfig)),
				}),
				{},
			),
		),
	]),
};
const defaultProps = {
	dataTestId: null,
	disabled: false,
	icon: <IconAccountCircle />,
	notification: undefined,
	size: 'large',
};

function Component({ ...props }) {
	const { dataTestId, disabled, text, notification, ...other } = props;

	return (
		<StyledIconButton
			className="fuse-icon-button"
			aria-label={notification ? `${notification} notification in ${text}` : undefined}
			as={disabled ? 'button' : ''}
			data-testid={dataTestId}
			disabled={disabled}
			{...other}
		>
			{notification && (
				<span className="fuse-icon-button__notification notification">{notification}</span>
			)}
			<span className="fuse-icon-button__text">{text}</span>
		</StyledIconButton>
	);
}

Component.propTypes = propTypes;
Component.defaultProps = defaultProps;

export default Component;
